import React, {useState} from 'react'
import {InjectedFormProps, reduxForm, SubmissionError} from 'redux-form'
import {UserActionTypes} from "../UserActions";
import {Dispatch} from "redux";
import {EMAIL_REGEXP_ALLOW_WILDCARD} from "./form";
import {isValid, matches, normalizePhone} from "./utils";
import {t} from "../../i18n";
import {BrandButton} from "../../ui/buttons/buttons";
import {ResetPasswordChannel, UserService} from '../UserService';
import {AppState} from "../../RootReducer";
import {useDispatch, useSelector} from "react-redux";
import {FormProvider, UnpackNestedValue, useForm} from "react-hook-form";
import {PrincipalSelector} from "../../onboardingpage/PrincipalSelector";
import {InputType, ReCaptchaAction, UserLoginPrincipal, UserPrimaryField} from "../../http/protocol";
import {createInput} from "../../onboardingpage/UserDetailsFormStep";
import {getContainer} from "../../ioc/IOCSetup";
import {executeCaptcha, isReCaptchaActionEnabled} from "../../ReCaptcha";
import { useHistory, useLocation } from 'react-router';
import { ResetPasswordStatus } from '../../http/Types';


const requiredText = (key : string) : string | any => {
    return t("forms.required", { label : t(key)});
}
const validateRequestResetPasswordForm= (values : {email: string, phoneNumber: string})=> {
    let error : any = {};

    if(!isValid(values.email,4,200)) {
        error.email = requiredText("email");
    }
    if(!matches(values.email,EMAIL_REGEXP_ALLOW_WILDCARD)) {
        error.email = t("forms.email.invalid");
    }
    return error;
}

type EmailOrPhone = "email" | "phone"

const RequestResetPasswordForm = () => {
    const loginPrincipals = useSelector((app : AppState) => app.journey.journey?.journey?.userLoginPrincipals ?? []);
    const [principal, setPrincipal] = useState(loginPrincipals?.[0] ?? UserLoginPrincipal.EMAIL);
    const [submitting, setSubmitting] = useState(false);
    const stateError = useSelector((app : AppState) => app.user.resetPasswordStatus);
    const settings = useSelector((app : AppState) => app.settings.settings);
    const dispatch = useDispatch();

    const methods = useForm({
        reValidateMode: 'onChange',
        mode: 'onChange'
    });

        
    const [inputEvent, setInputEvent] = React.useState<string>("");

    const handleFocus = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputEvent(event.type);
    }

    const {register, handleSubmit, setValue, setError, formState: {errors, isValid}, watch} = methods;
    const history = useHistory();
    const onSubmit = async (data : UnpackNestedValue<any>) => {
        setSubmitting(true);
        let channel : ResetPasswordChannel = "email";
        let address = data.email;
        if(principal == UserLoginPrincipal.PHONE_NUMBER) {
            channel = "sms";
            address = normalizePhone(data.phoneNumber);
        }
        let captchaToken;
        if(isReCaptchaActionEnabled(ReCaptchaAction.recoverPassword, settings)) {
            try {
                captchaToken = await executeCaptcha(ReCaptchaAction.recoverPassword, settings?.reCaptchaSettings?.siteKey);
            } catch (e) {
                dispatch({ type : UserActionTypes.REQUEST_RECOVER_PASSWORD_ERROR, error : e, channel : channel});
            }
        }
        let userService : UserService = getContainer().getUserService();

        try {
            await userService.requestResetPassword(address, channel, captchaToken);
            
            await dispatch({ type : UserActionTypes.REQUEST_RECOVER_PASSWORD, channel: channel, address: address});

            if (channel == "sms") {
                history.push(`/playnow/resetpassword`)
            }


        } catch (e: any) {
            setSubmitting(false);
            console.error("Request password error", e);
            dispatch({ type : UserActionTypes.REQUEST_RECOVER_PASSWORD_ERROR, error : e, channel : channel});

        }
    }
    let input = { type : InputType.LOGIN_PRINCIPAL, field : UserPrimaryField.loginPrincipal, name : "loginPrincipal"};
    return (
        <FormProvider {...methods} >
            <form className={`form recover ${inputEvent == "focus" ? "recover-form-focus" : "" }`} onSubmit={handleSubmit(onSubmit)}>
                {stateError && (
                    <div className={"alert alert-danger"}>
                        {t("forms.resetPassword.serverError")}
                    </div>
                )}
                {loginPrincipals.length > 1 && (
                    <div className={"form-group-container"}>
                        <PrincipalSelector principals={loginPrincipals}
                                           principal={principal}
                                           hideDescription={true}
                                           setPrincipal={(p: UserLoginPrincipal) => setPrincipal(p)}/>
                    </div>

                )}

                {createInput(principal, input, register, errors, watch, setValue, undefined, handleFocus)}


                <BrandButton className={`btn btn-cta full-width ${inputEvent == "focus" ? "btn-focus" : ""}`} loading={submitting}
                             type="submit"
                             onMouseDown={event => event.preventDefault()}
                             disabled={!isValid}>
                    {t("account.resetPassword")}
                </BrandButton>

            </form>
        </FormProvider>

    )
};
export default RequestResetPasswordForm;

